import Navbar from "../Navbar/Navbar"
import UserProfile from "../UserProfile/UserProfile"
const ProfilePage = () => {
    return (
        <>
            <Navbar />
            <UserProfile />
        </>
    )
}
export default ProfilePage
